module.exports = __webpack_public_path__ + "static/img/MITCH-SZYBKOWSKI.6ebdf89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MITCH-SZYBKOWSKI.jpg
// module id = yJ6S
// module chunks = 0